<template>
  <div class="settings">
    <h4 class="slds-tree__group-header" id="treeheading">{{ $t ('sections.settings') }}</h4>
    <ul aria-labelledby="treeheading" class="slds-tree" role="tree">
      <li
        aria-level="1"
        role="treeitem"
        v-for="(setting, index) in settings"
        :aria-expanded="index === expandedSectionIndex"
        :aria-label="$t(`setting.${setting.label}`)"
        :key="setting.label">
        <div class="slds-tree__item" @click="toggleSection(index)">
          <button class="slds-button slds-button_icon slds-m-right_x-small" aria-hidden="true" tabindex="-1">
            <svg class="slds-button__icon slds-button__icon_small" aria-hidden="true">
              <use xlink:href="../assets/symbols.svg#chevronright"></use>
            </svg>
          </button>
          <span class="slds-has-flexi-truncate">
            <span class="slds-tree__item-label slds-truncate" :title="$t(`setting.${setting.label}`)">{{ $t(`setting.${setting.label}`) }}</span>
          </span>
        </div>
        <ul role="group">
          <LocaleChooser v-model="$i18n.locale" class="languages" />
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
import LocaleChooser from '../components/LocaleChooser'
import settings from '../config/settings'
export default {
  components: {
    LocaleChooser
  },
  data () {
    return {
      expandedSectionIndex: -1,
      settings
    }
  },
  methods: {
    toggleSection (index) {
      if (this.expandedSectionIndex === index) {
        this.expandedSectionIndex = -1
      } else {
        this.expandedSectionIndex = index
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .languages {
    overflow-y: auto;
    max-height: 20vh;
  }
</style>
